import { Outlet, RouteObject } from 'react-router-dom';
import { ProfessionalLayout, ProfessionalSessionCallLayout } from '@/layouts';
import {
	CreateProfessionalAgenda,
	ProfessionalRegister,
	ProfessionalHome,
	WelcomeProfessional,
	StepFour,
	StepOne,
	StepThree,
	StepTwo,
	ProfessionalLogin,
	ProfessionalAgenda,
	ProfessionalProfile,
	CreateProfessionalUnavailability,
	AvailableExplanation,
	ProfessionalRepassePage,
	ProfessionalSessaoChamadaPage,
	ProfessionalTutorialDemonstracaoPage,
	CreateProfessionalSession,
	ProfessionalPatients,
} from '@/pages';

export const professionalRoutes: Array<RouteObject> = [
	{
		path: 'profissional',
		children: [
			{
				path: 'cadastro',
				element: <Outlet />,
				children: [
					{
						path: '',
						element: <ProfessionalRegister />,
					},
					{
						path: 'info-pessoal',
						element: <StepOne />,
					},
					{
						path: 'info-documentacao',
						element: <StepTwo />,
					},
					{
						path: 'info-contato',
						element: <StepThree />,
					},
					{
						path: 'info-modalidade',
						element: <StepFour />,
					},
				],
			},
			{
				path: 'login',
				element: <ProfessionalLogin />,
			},
			{
				path: 'repasse',
				element: <ProfessionalRepassePage />,
			},
			{
				path: '',
				element: <ProfessionalLayout />,
				children: [
					{
						path: 'autorizacao',
						element: <WelcomeProfessional />,
					},
					{
						path: 'home',
						element: <ProfessionalHome />,
					},
					{
						path: 'consultas/agendar',
						element: <CreateProfessionalSession />,
					},
					{
						path: 'pacientes',
						element: <ProfessionalPatients />,
					},
					{
						path: 'horarios',
						children: [
							{
								path: '',
								element: <ProfessionalAgenda />,
							},
							{
								path: 'disponibilidade/criar',
								element: <CreateProfessionalAgenda />,
							},
							{
								path: 'disponibilidade/guia',
								element: <AvailableExplanation />,
							},
							{
								path: 'indisponibilidade/criar',
								element: <CreateProfessionalUnavailability />,
							},
						],
					},
					{
						path: 'perfil',
						element: <ProfessionalProfile />,
					},
				],
			},
			{
				path: 'sessao-chamada/:sessionId',
				element: <ProfessionalSessionCallLayout />,
				children: [
					{
						path: '',
						element: <ProfessionalSessaoChamadaPage />,
					},
				],
			},
			{
				path: 'tutorial/demonstracao',
				element: <ProfessionalSessionCallLayout />,
				children: [
					{
						path: '',
						element: <ProfessionalTutorialDemonstracaoPage />,
					},
				],
			},
		],
	},
];
